import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    // Prüfe ob das Content-Target vorhanden ist
    if (!this.hasContentTarget) {
      return
    }
    
    // Optional: Speichern des Zustands in localStorage
    const isOpen = localStorage.getItem('requisitionFormOpen') === 'true'
    if (isOpen) {
      this.open()
    }
  }

  toggle() {
    // Prüfe ob das Content-Target vorhanden ist
    if (!this.hasContentTarget) {
      return
    }
    
    this.contentTarget.classList.toggle('hidden')
    
    // Icon ist optional - nur wenn vorhanden, rotieren
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('rotate-180')
    }
    
    // Optional: Speichern des Zustands in localStorage
    localStorage.setItem('requisitionFormOpen', !this.contentTarget.classList.contains('hidden'))
    
    // Dispatch event for sidebar toggle (for CRM layout)
    document.dispatchEvent(new CustomEvent('mobile-menu-toggled'))
  }

  open() {
    // Prüfe ob das Content-Target vorhanden ist
    if (!this.hasContentTarget) {
      return
    }
    
    this.contentTarget.classList.remove('hidden')
    
    // Icon ist optional - nur wenn vorhanden, rotieren
    if (this.hasIconTarget) {
      this.iconTarget.classList.add('rotate-180')
    }
  }

  close() {
    // Prüfe ob das Content-Target vorhanden ist
    if (!this.hasContentTarget) {
      return
    }
    
    this.contentTarget.classList.add('hidden')
    
    // Icon ist optional - nur wenn vorhanden, rotieren
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove('rotate-180')
    }
  }
} 